import React from 'react'

function FilledPointerIcon () {
  return (
    <div>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='52'
        height='52'
        viewBox='0 0 52 52'
      >
        <g
          id='Group_12546'
          data-name='Group 12546'
          transform='translate(-40 -816)'
        >
          <rect
            id='Rectangle_7223'
            data-name='Rectangle 7223'
            width='52'
            height='52'
            rx='16'
            transform='translate(40 816)'
            fill='#e8925c'
          />
          <path
            id='ads_click_24dp_000000_FILL1_wght300_GRAD0_opsz24_1_'
            data-name='ads_click_24dp_000000_FILL1_wght300_GRAD0_opsz24 (1)'
            d='M113.245-838.089a7.881,7.881,0,0,1-5.262-2.551,7.73,7.73,0,0,1-2.132-5.465,7.757,7.757,0,0,1,2.346-5.7,7.757,7.757,0,0,1,5.7-2.346,7.743,7.743,0,0,1,5.465,2.125,7.854,7.854,0,0,1,2.551,5.255l-2.326-.689a5.77,5.77,0,0,0-2.043-3.236,5.648,5.648,0,0,0-3.647-1.261,5.633,5.633,0,0,0-4.132,1.719,5.633,5.633,0,0,0-1.719,4.132,5.652,5.652,0,0,0,1.268,3.656,5.8,5.8,0,0,0,3.229,2.048ZM115-832.27a2.634,2.634,0,0,1-.552.059h-.553a13.531,13.531,0,0,1-5.419-1.094,14.032,14.032,0,0,1-4.411-2.969,14.027,14.027,0,0,1-2.97-4.411A13.523,13.523,0,0,1,100-846.1a13.536,13.536,0,0,1,1.094-5.419,14.036,14.036,0,0,1,2.969-4.413,14.035,14.035,0,0,1,4.411-2.971A13.523,13.523,0,0,1,113.892-860a13.532,13.532,0,0,1,5.419,1.094,14.032,14.032,0,0,1,4.413,2.97,14.036,14.036,0,0,1,2.971,4.411,13.529,13.529,0,0,1,1.094,5.419v.546a2.569,2.569,0,0,1-.059.546l-2.135-.653v-.439a11.292,11.292,0,0,0-3.4-8.3,11.293,11.293,0,0,0-8.3-3.4,11.293,11.293,0,0,0-8.3,3.4,11.293,11.293,0,0,0-3.4,8.3,11.292,11.292,0,0,0,3.4,8.3,11.292,11.292,0,0,0,8.3,3.4h.439Zm10.8.27-6.632-6.646-1.589,4.8-3.685-12.263,12.263,3.685-4.8,1.589L128-834.2Z'
            transform='translate(-47.999 1688)'
            fill='#fff'
          />
        </g>
      </svg>
    </div>
  )
}

export default FilledPointerIcon
